<!--
* @program: office_automation 
* @author: ly
* @component:staffPromotion 
* @description: 员工晋升
* @create: 2022-03-08 10:11
-->
<template>
    <div class="oa-content">
        <div class="oa-window">
            <div v-if="visible" style="display: flex;flex-wrap: wrap;max-height: 100%;overflow: auto;">
                <div class="flat-component" v-for="item in showComps" :key="item.comp" @click="clickItem(item)" :style="item.style" >
                    {{item.title}}
                </div>
            </div>
            <div style="right: 100%" v-else>
                <a-page-header style="padding: 0; border: 1px solid rgb(235, 237, 240)">
                    <template #title>
                        <div style="display: flex;">
                            <div style="margin: 20px">
                                <a-button style="margin-right: 20px" danger @click = "visible = true" >返回</a-button>
                                <span >{{currentComp.title}}</span>
                            </div>
                        </div>
                    </template>
                </a-page-header>
                <div v-is="currentComp.comp" />
            </div>
        </div>
    </div>
</template>

<script>
    import StaffPromotionSetting from "./StaffPromotionSetting/StaffPromotionSetting";
    import StaffPromotionAudit from "./StaffPromotionSetting/StaffPromotionAudit";
    import DoPromotion from "../../personalCenter/PersonalAssessment/Promotion/DoPromotion";
    export default {
        name: "staffPromotion",
        components:{
            StaffPromotionSetting,StaffPromotionAudit,DoPromotion
        },
        computed:{
            showComps(){
                return this.components.filter(item=>item.enable)
            }
        },
        data(){
            return{
                components:[
                    {title:"晋升审核",comp:"StaffPromotionAudit",enable:true,
                        style:"width:300px;background-image: linear-gradient(#FF3853, #fff);"},
                    {title:"晋升评分",comp:"DoPromotion",enable:true,
                        style:"width:300px;background-image: linear-gradient(#FF3853, #fff);"},
                    {title:"晋升考核科目配置",comp:"StaffPromotionSetting",enable:true,
                        style:"width:300px;background-image: linear-gradient(#FF3853, #fff);"},
                ],
                currentComp:null,
                visible:true
            }
        },
        methods:{
            clickItem(item){
                this.currentComp = item;
                this.visible = false;
            }
        }
    }
</script>

<style scoped>

</style>